import React from 'react';
import { Link } from 'react-router-dom';

const TermsOfService = () => {
  return (
    <div className="min-h-screen bg-slate-50 py-12 px-6">
      <div className="max-w-4xl mx-auto bg-white rounded-2xl shadow-sm p-8">
        <div className="mb-8">
          <Link to="/" className="text-[#0EA5E9] hover:text-[#0284c7] text-sm font-medium">
            ← Back to PassportTalk
          </Link>
        </div>
        
        <h1 className="text-4xl font-bold text-travel-navy font-outfit mb-4">Terms of Service</h1>
        <p className="text-sm text-slate-600 mb-8">
          <strong>Effective Date:</strong> January 1, 2025<br />
          <strong>Last Updated:</strong> January 5, 2025
        </p>

        <div className="prose prose-slate max-w-none">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using PassportTalk ("Service", "App", "Platform"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, do not use the Service.
          </p>

          <h2>2. Beta Program Notice</h2>
          <div className="bg-[#0EA5E9]/10 border-2 border-[#0EA5E9]/20 rounded-xl p-6 my-6">
            <p className="font-semibold text-travel-navy mb-3">IMPORTANT: PassportTalk is currently in beta testing.</p>
            <p className="text-sm">By using the Service during beta:</p>
            <ul className="text-sm mt-2">
              <li>You acknowledge that features, pricing, and availability may change without notice</li>
              <li>The Service is provided "as-is" with no guaranteed uptime or support SLA</li>
              <li>You may encounter bugs, errors, or service interruptions</li>
              <li>Your feedback helps us improve the Service</li>
              <li>Beta access may be modified or terminated at any time</li>
            </ul>
          </div>

          <h2>3. Description of Service</h2>
          <p>PassportTalk provides:</p>
          <ul>
            <li><strong>AI-Powered Translation:</strong> Automated text translation between English and Spanish</li>
            <li><strong>Live Agent Support:</strong> Real-time human interpreter services via WhatsApp voice calls</li>
            <li><strong>Communication Tools:</strong> Voice input, text-to-speech, saved phrases, and favorites</li>
          </ul>

          <h3>Service Limitations</h3>
          <div className="bg-red-50 border border-red-200 rounded-lg p-4 my-4">
            <p className="font-semibold text-red-900 mb-2">PassportTalk is NOT:</p>
            <ul className="text-sm text-red-800">
              <li>Medical or legal advice</li>
              <li>A professional translation service for official documents</li>
              <li>An emergency medical or legal service</li>
              <li>A guarantee of accurate interpretation in all contexts</li>
            </ul>
          </div>

          <h2>4. Payments and Billing</h2>
          <h3>Pricing</h3>
          <ul>
            <li><strong>AI Translation:</strong> Free during beta (subject to change)</li>
            <li><strong>Live Agent Calls:</strong> $2.00 USD per minute (subject to change)</li>
            <li>Prices displayed before service initiation</li>
            <li>Billing begins when call connects</li>
          </ul>

          <h2>5. Refund Policy</h2>
          <p>
            See our complete <Link to="/refunds" className="text-[#0EA5E9] hover:underline">Refund Policy</Link> for details.
          </p>
          <p><strong>Summary:</strong></p>
          <ul>
            <li>Refunds considered for technical issues only</li>
            <li>No refunds for completed calls or used services</li>
            <li>Beta users: Refunds handled case-by-case</li>
            <li>Request refunds within 7 days of charge</li>
          </ul>

          <h2>6. Privacy and Data</h2>
          <p>
            See our <Link to="/privacy" className="text-[#0EA5E9] hover:underline">Privacy Policy</Link> for complete details.
          </p>

          <h2>7. Disclaimers</h2>
          <h3>Service Availability</h3>
          <p className="font-semibold">THE SERVICE IS PROVIDED "AS-IS" AND "AS-AVAILABLE":</p>
          <ul>
            <li>No guarantee of uptime or availability</li>
            <li>We may modify, suspend, or discontinue features</li>
            <li>Beta services may be unstable or unreliable</li>
            <li>Maintenance may cause temporary outages</li>
          </ul>

          <h2>8. Limitation of Liability</h2>
          <p className="font-semibold">TO THE MAXIMUM EXTENT PERMITTED BY LAW:</p>
          <p>We are NOT liable for:</p>
          <ul>
            <li>Inaccurate translations or interpretations</li>
            <li>Missed calls or unavailable agents</li>
            <li>Service outages or technical issues</li>
            <li>Loss of data or content</li>
            <li>Indirect, incidental, or consequential damages</li>
            <li>Damages exceeding amounts paid in the last 3 months</li>
          </ul>

          <h2>9. Contact Information</h2>
          <p><strong>For questions, support, or legal matters:</strong></p>
          <ul className="list-none">
            <li><strong>Email:</strong> support@passtalkapp.com</li>
            <li><strong>Website:</strong> https://passtalkapp.com</li>
          </ul>
        </div>

        <div className="mt-12 pt-8 border-t border-slate-200">
          <p className="text-sm text-slate-600 text-center">
            <strong>Last Updated:</strong> January 5, 2025 | <strong>Version:</strong> 1.0 (Beta)
          </p>
          <p className="text-xs text-slate-500 text-center mt-4">
            By using PassportTalk, you acknowledge that you have read, understood, and agree to these Terms of Service.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService;